import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { actions as modalActions } from '@saucelabs/sl-container-modal';
import { change } from 'redux-form';

import * as api from './api';
import * as types from './types';
import * as constants from './constants';

export const getSubaccounts = createApiAction(
  types.GET_SUBACCOUNTS, api.getSubaccounts,
);
export const getTransferStatus = createApiAction(
  types.GET_TRANSFER_STATUS, api.getTransferStatus,
);
export const transferOrganization = createApiAction(
  types.TRANSFER_ORGANIZATION, api.postTransferOrganization,
);

export const initialized = createAction(types.INITIALIZED);
export const getOrgCsv = createAction(types.GET_ORG_CSV);
export const removeCsv = () => (dispatch) => (
  dispatch(change(constants.FORM_NAME, 'csv', null))
);

export const setTeams = createAction(types.SET_TEAMS);
export const showError = createAction(types.SHOW_ERROR);

export const openLoadingModal = () => (dispatch) => (
  dispatch(modalActions.showModal(constants.LOADING_MODAL_NAME))
);

export const hideLoadingModal = () => (dispatch) => (
  dispatch(modalActions.hideModal(constants.LOADING_MODAL_NAME))
);

export const openEditTeamConcurrencyModal = () => (dispatch) => (
  dispatch(modalActions.showModal(constants.EDIT_TEAM_CONCURRENCY_MODAL_NAME))
);

export const hideEditTeamConcurrencyModal = () => (dispatch) => (
  dispatch(modalActions.hideModal(constants.EDIT_TEAM_CONCURRENCY_MODAL_NAME))
);

export const redirectToTeamManagement = () => {
  window.location.assign('/team-management');
};

// status poller
export const subscribeTransferStatus = createAction(types.SUBSCRIBE_TRANSFER_STATUS);
export const unsubscribeTransferStatus = createAction(types.UNSUBSCRIBE_TRANSFER_STATUS);
